import type * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
export type UserBasicsFragment = { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null };

export type PlaybookTileFragment = { playbook: { id: number, name: string, nameSuffix: string | null, protectedPlaybook: boolean | null, description: string | null, standard: boolean | null, config: { icon: string | null } | null, type: { id: number | null, class: string | null }, categories: Array<{ name: string }> } };

export type JobEventTileFragment = { id: number, name: string, status: Types.JobStatusEnum | null, created: string | null, tool: string | null, owner: { display: string | null, id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null } | null, params: { blast: { blastType: string | null } | null } | null };

export const PlaybookTileFragmentDoc = gql`
    fragment PlaybookTile on PlaybookEvent {
  playbook {
    id
    name
    nameSuffix
    protectedPlaybook
    description
    standard
    config {
      icon
    }
    type {
      id
      class
    }
    categories {
      name
    }
  }
}
    `;
export const UserBasicsFragmentDoc = gql`
    fragment UserBasics on User {
  id
  username
  firstName
  lastName
  email
  display
}
    `;
export const JobEventTileFragmentDoc = gql`
    fragment JobEventTile on BlastJob {
  id
  name
  status
  created
  owner {
    ...UserBasics
    display
  }
  tool
  params {
    blast {
      blastType
    }
  }
}
    ${UserBasicsFragmentDoc}`;